import { useNavigate } from 'react-router';
import Logo from '../../components/logo';

const Start = () => {
  const navigate = useNavigate();

  return (
    <div className='relative h-dvh w-full'>
      {/* Video Background */}
      <div className='absolute inset-0 z-0'>
        <video
          autoPlay
          loop
          muted
          playsInline
          className='w-full h-full object-cover brightness-50'
        >
          <source
            src='https://static-resource.thechamps.app/vod/start.mp4'
            type='video/mp4'
          />
        </video>
      </div>

      <div className='relative z-10 py-8 px-4 flex flex-col items-center justify-between h-full'>
        <Logo size='text-3xl' />

        {/* Content at Bottom */}
        <div className='flex flex-col items-center justify-end h-full'>
          {/* Hero Copy */}
          <h2 className='text-6xl font-bold text-white text-center'>
            Build your momentum
          </h2>
          <p className='text-gray-200 text-center mb-4 text-sm'>
            All levels of challenges and AI tracker available.
            <br />
            Join the community today.
          </p>

          {/* CTA Buttons */}
          <div className='flex flex-col w-full gap-3'>
            <button
              onClick={() => navigate('/signup')}
              className='w-full py-3 bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200'
            >
              Sign up
            </button>
            <p className='text-base text-white text-center'>
              Already have an account?
              <a
                onClick={() => navigate('/signin')}
                className='text-white font-semibold underline ml-2'
              >
                Sign In
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Start;
